// 应用配置常量

// 应用名称 - 用于显示在界面上
export const APP_NAME = 'RFPAY'

// 隐私政策联系邮箱
export const PRIVACY_POLICY_EMAIL = 'support@rfpay.onl'

// 隐私政策公司
export const PRIVACY_POLICY_COMPANY = 'RFPAY'